export default "__VITE_ASSET__XOAA6xyF__"